<template>
  <LoginHolder>
    <v-container class="container-bg-color pa-0" fluid fill-height>
      <v-row align="center" style="height:100%; min-width:300px">
        <v-col cols="12">
          <AlertMessage :alerMessage="alerMessage"></AlertMessage>
        </v-col>
        <v-col cols="12" v-if="loading">
          <h2 class="mb-1 pb-3">Confirming account.</h2>
          <p>Please wait...</p>
        </v-col>
        <v-col cols="12" align="center" v-if="!loading">
          <p v-if="validToken">Your account has been confirmed.</p>
          <v-btn
            depressed
            block
            rounded
            large
            color="primary"
            :to="{ name: 'login' }"
            v-if="validToken"
          >
            Login
          </v-btn>
          <v-btn
            depressed
            block
            rounded
            large
            color="primary"
            :to="{ name: 'resend-confirmation-token' }"
            v-if="!validToken"
          >
            Resend Token
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </LoginHolder>
</template>

<script>
  import LoginHolder from './LoginHolder.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'

  export default {
    name: 'ConfirmRegistration',
    data: () => ({
      token: '',
      validToken: false,
      loading: false,
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },

    }),
    methods: {
      confirmToken(){
        if(this.loading){
          return false;
        }

        this.loading = true
        let self = this
        this.$http.plain.get('users/confirm-registration?token='+this.token)
          .then(response => {
            this.validToken = true
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
    },
    mounted() {
      if(this.$route.query.token){
        this.token = this.$route.query.token
        this.confirmToken()
      }else{
        this.alerMessage.messages = ['Invalid token']
        this.alerMessage.show = true
      }
    },
    components: {
      SnackBar,
      LoginHolder,
      AlertMessage
    },
  }
</script>
